import React, { Fragment } from "react";

function AboutContentFr() {
  return (
    <Fragment>
      <section className="about_banner" dir="ltr">
        <div className="container">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6 d-flex align-items-center">
              <div className="col_selector text-right">
                <h2 className="poppinssemibold mb-2">À propos</h2>
                <p className="fz13 poppinsregular">Nous croyons qu'en rassemblant nos voisins, nous pouvons cultiver un monde plus gentil où chacun a un quartier sur lequel il peut compter.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="terms_condition_section about_page pb-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="col_selector">
                <h3 className="fz18 poppinssemibold mb-4">Introduction</h3>
                <p>Houmti est une application sociale et e-commerce qui vous aide à rester connecté avec vos voisins. En tant qu'alternative aux formes traditionnelles de médias sociaux, Houmti vous permet de nouer des relations plus étroites avec vos voisins et de rester au courant des dernières nouvelles et offres dans votre quartier.</p>
                <p>Il est plus facile d'obtenir des informations sur les services (privés et publics) et les entreprises auprès de sources de confiance, vos voisins dans la même Daira ou les Dairas environnantes.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
}

export default AboutContentFr;
